module.exports = __webpack_public_path__ + "img/logo-s.4f2ad0a9.png";